import { render } from "./LInfoLinksHome.vue?vue&type=template&id=628d6b43&scoped=true&ts=true"
import script from "./LInfoLinksHome.vue?vue&type=script&lang=ts"
export * from "./LInfoLinksHome.vue?vue&type=script&lang=ts"

import "./LInfoLinksHome.vue?vue&type=style&index=0&id=628d6b43&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628d6b43"]])

export default __exports__